export function DifferentialPaySvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/differential-pay.svg'"></ng-include>`
    }
}